import "core-js/modules/es.array.map";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addAdCallbackToken } from "@/api/financial/backhaul";
import { serchSelect, serchSelectManage } from "@/mixins/index";
export default {
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        special_product_id: "",
        token: ''
      },
      rules: {
        // special_product_id: [{ required: true, message: "请选择", trigger: "blur" }],
        token: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (row) {
                  data = _objectSpread({}, row);
                  data.params = data.params ? JSON.parse(data.params).map(function (i) {
                    return {
                      value: i
                    };
                  }) : [];
                  _this.formData = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.formData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (!_this2.formData.special_product_id) {
            _this2.formData.special_product_id = _this2.searchData.special_product_id;
          }

          _this2.formData.game_id = _this2.searchData.game_id;
          var data = JSON.parse(JSON.stringify(_this2.formData));
          addAdCallbackToken(data).then(function (res) {
            if (res.status == 200) {
              _this2.$Message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      var _this3 = this;

      this.formData = {
        id: this.formData.id,
        special_product_id: "",
        token: ''
      };
      this.$nextTick(function () {
        _this3.$refs.ruleForm.resetFields();
      });
    }
  }
};